import React, { CSSProperties, useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import {isMobile} from 'react-device-detect'

import { MATRIX_DATA } from './data/matrix-data'

import { constants } from '../../Constants';

import CustomContainer from '../Layout/CustomContainer'

import { getOrgStageCoords, IOrgStageCoordsGetterOutput } from './functions/getOrgStages-1';
import RootStoreContext from '../../storage/RootStore';

import { When } from 'react-if';
import { motion } from 'framer-motion/dist/framer-motion'



import {
    Documents, Problems, RowLabels, ChartHeader, Blocks, Lines, NodeCircles, NodeCirclesExtended
} from './components';

import './Matrix.scss'
import { Selector } from './components/Selector';
import { View } from '../../storage/Selection';
import { Stages } from './components/Views/Stages';
import { Structure } from './components/Views/Structure/Structure';
import { Box } from '@material-ui/core';


interface Props {
    isDesktop: boolean,
    style: CSSProperties
}



export const Matrix: React.FC<Props> = observer(({ isDesktop }) => {

    const { BLOCK } = constants;

    const { selection, dataset, dimensions } = useContext(RootStoreContext)

    useEffect(() => {
        const d = getOrgStageCoords(MATRIX_DATA)
        // Uploadinf dataset
        console.log('d')
        console.log(d)
        dataset.set(d)
    }, [dataset])
    


    const stagesCount = MATRIX_DATA[0].length - 1;
    const orgsCount = MATRIX_DATA.length - 1

    let svgWidth = (stagesCount + 1) * (BLOCK.WIDTH);
    let svgHeight = 11 + orgsCount * BLOCK.HEIGHT;


    const getAnimationStyles = (visible: boolean) => {
        return {
            transtion: { duration: 0.5 },
            animate: {
                opacity: visible ? 1 : 0,
                display: visible ? 'block' : 'none'
            }
        }
    }


    const containerProps = {
        maxWidth: 'xl' as 'xl',
        classNames: 'reset',
        isDesktop: isDesktop,
        scrollable: false,
    }

    const containerStyles = {
        flexDirection: 'column' as 'column',
        height: dimensions.HEIGHT_MATRIX_CONTAINER
    }
    
    const wrapperStyles: CSSProperties = {
        background: constants.MAPAREA.COLOR_BG,
        alignItems: isMobile ? 'start' : 'center',
        flexDirection: 'column'
    }


    return dataset.loaded && (<>

        <Box className='matrix-wrapper' style={wrapperStyles}>

        <h3 style={{margin: '0 auto', color:'#203752'}}>Процеси реєстрації та обміну даними про випадки та причини смерті</h3>
            <CustomContainer centerContent={true} {...containerProps} styles={containerStyles}>

                <Selector />

                {/* <When condition={selection.view !== 'structure'}> */}
                <motion.div {...getAnimationStyles(selection.view !== 'structure')}>
                    <div className='matrix-svg-wrapper'>

                        {/* First row with column titles */}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${svgWidth} ${BLOCK.HEIGHT}`} width={svgWidth} height={BLOCK.HEIGHT} preserveAspectRatio="none">
                            <ChartHeader {...dataset.current} />
                        </svg>

                        {/* Main matrix */}
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox={`0 0 ${svgWidth} ${svgHeight - 2}`} width={svgWidth} height={svgHeight}
                            preserveAspectRatio="none">

                            <g id="group-45" width={svgWidth}  >

                                <motion.g {...getAnimationStyles(selection.view === 'stages')}>
                                    <Stages {...dataset.current} />
                                </motion.g>

                                <motion.g {...getAnimationStyles(selection.view === 'documents')}>
                                    <Documents {...dataset.current} />
                                </motion.g>

                                <motion.g {...getAnimationStyles(selection.view === 'problems')}>
                                    <Problems {...dataset.current} />
                                </motion.g>
                            </g>
                        </svg>
                    </div>
                </motion.div>

                <When condition={selection.view === 'structure'}>
                    {/* <motion.div {...getAnimationStyles(selection.view === 'structure')}> */}
                        <div>
                        <Structure  />
                        </div>
                       
                    {/* </motion.div> */}
                </When>

            </CustomContainer>
        </Box>
    </>
    )
})


